module.exports = __webpack_public_path__ + "img/image-to-camera.c4929956.png";